import HotkeyManager from './HotkeyManager';

// Editor hotkey manager
export default new HotkeyManager();
